import { render } from "./ProjectCreator.vue?vue&type=template&id=d98aff1c&scoped=true"
import script from "./ProjectCreator.vue?vue&type=script&lang=js"
export * from "./ProjectCreator.vue?vue&type=script&lang=js"

import "./ProjectCreator.vue?vue&type=style&index=0&id=d98aff1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98aff1c"]])

export default __exports__